import React, { useMemo } from "react";

const MONTHS = {
  fr: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
};

function level(v) {
  if (!v) return "bg-zinc-800/60";
  if (v === 1) return "bg-primary/30";
  if (v === 2) return "bg-primary/60";
  return "bg-primary";
}

function toKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function Heatmap({ counts, year, lang = "en" }) {
  const { weeks, monthLabels } = useMemo(() => {
    const start = new Date(year, 0, 1);
    const end = new Date(year, 11, 31);
    const offset = (start.getDay() + 6) % 7; // Monday-first
    const gridStart = new Date(start);
    gridStart.setDate(start.getDate() - offset);

    const cols = [];
    const labels = [];
    let cur = new Date(gridStart);
    let weekIdx = 0;
    let lastMonth = -1;
    while (cur <= end) {
      const col = [];
      const weekMonth = cur.getMonth();
      const weekYear = cur.getFullYear();
      for (let i = 0; i < 7; i++) {
        const inYear = cur.getFullYear() === year;
        const key = toKey(cur);
        col.push({ key, inYear, value: inYear ? counts[key] || 0 : null });
        cur = new Date(cur);
        cur.setDate(cur.getDate() + 1);
      }
      cols.push(col);
      if (weekYear === year && weekMonth !== lastMonth) {
        labels.push({ idx: weekIdx, month: weekMonth });
        lastMonth = weekMonth;
      }
      weekIdx++;
    }
    return { weeks: cols, monthLabels: labels };
  }, [counts, year]);

  return (
    <div className="overflow-x-auto" data-testid="heatmap">
      <div className="inline-flex flex-col gap-1 min-w-max">
        <div className="flex gap-1 ml-0 mb-1 h-3 relative">
          {weeks.map((col, i) => {
            const lbl = monthLabels.find((m) => m.idx === i);
            return (
              <div key={col[0].key} className="w-3 text-[9px] text-zinc-500 relative">
                {lbl ? <span className="absolute left-0 whitespace-nowrap">{MONTHS[lang][lbl.month]}</span> : null}
              </div>
            );
          })}
        </div>
        <div className="flex gap-1">
          {weeks.map((col) => (
            <div key={col[0].key} className="flex flex-col gap-1">
              {col.map((cell) => (
                <div
                  key={cell.key}
                  data-testid={cell.inYear && cell.value > 0 ? `heat-${cell.key}` : undefined}
                  title={cell.inYear ? `${cell.key} · ${cell.value}` : ""}
                  className={`w-3 h-3 rounded-[2px] ${cell.inYear ? level(cell.value) : "bg-transparent"}`}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
